module.exports = __webpack_public_path__ + "img/tax_popup.94cc198b.png";